"use client";

import { useTable } from "spacetimedb/react";
import { useAccountReadiness } from "@/providers/account-readiness";
import { tables } from "@/module_bindings";
import { mapOrganization } from "@/lib/stdb-map";
import type { Organization } from "@/types/organization";

export function useMyOrganizations(): {
  organizations: Organization[];
  isReady: boolean;
} {
  const accountReady = useAccountReadiness();
  const [rows, isReady] = useTable(tables.my_organizations);
  return {
    organizations: rows
      .map(mapOrganization)
      .sort((a, b) => ((a.createdAt ?? "") < (b.createdAt ?? "") ? -1 : 1)),
    isReady: accountReady || isReady,
  };
}
